import React from "react"

class PaymentBillingAddressGuest extends React.Component {
  render() {
    const { addressMode, billingAddress } = this.props;
    const showPanel =
      addressMode !== "BRANCH_DELIVERY" ? (
        <div className="fl-fb-50">
          <div className="selected--billing-address">
            <ul>
              <li>{billingAddress.name}</li>
              <li>{billingAddress.line1}</li>
              <li>{billingAddress.line2}</li>
              <li>{billingAddress.line3}</li>
              <li>{billingAddress.line4}</li>
              <li>{billingAddress.line5}</li>
              <li>{billingAddress.postcode}</li>
            </ul>
          </div>
        </div>
      ) : null;

    return showPanel;
  }
}

export default PaymentBillingAddressGuest;
